const copyAdv = {
  holder: document.querySelectorAll(".jsMenuAdvert") as NodeListOf<HTMLElement>,
  advert: document.getElementById("menuAdvert") as HTMLElement | undefined,

  init() {
    this.setAdvert();
  },
  setAdvert() {
    if (this.advert) {
      const html = this.advert.innerHTML;

      this.holder.forEach((item) => {
        item.innerHTML = html;
      });
    }
  },
};

export default copyAdv;
